import { FelaCSS } from '@bridebook/ui/src/components/fela/flowtypes';
import { colors, spacing } from '@bridebook/ui/src/themes/variables';

interface IStyles {
  header: FelaCSS;
  wrapper: FelaCSS;
  labelWrap: FelaCSS;
  icon: FelaCSS;
  label: FelaCSS;
}

const styles: IStyles = {
  header: {
    marginBottom: '8px',
    fontDefaultBold: 16,
    color: colors.space,
    marginTop: spacing[4],
    minWidthTablet: {
      marginTop: spacing[6],
    },
  },

  wrapper: {
    marginBottom: '8px',
  },

  labelWrap: {
    flexDirection: 'row',
    marginTop: '4px',
    marginBottom: '4px',
    alignItems: 'center',
  },

  icon: {
    marginTop: '1px',
  },

  label: {
    marginLeft: '8px',
    color: colors.space75,
    fontDefault: 14,
  },
};

export default styles;
